import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftCouponTheme,
  GiftCouponThemeCreate,
  GiftCouponThemeUpdate,
} from './giftCouponTheme.interface';

// 생성
export const createGiftCouponTheme = async (
  data: GiftCouponThemeCreate,
  role: LowerRole,
): Promise<GiftCouponTheme> => {
  const res = await api_.post(`/${role}/gift-coupon-theme`, data);
  return res.data;
};

// 수정
export const updateGiftCouponTheme = async (
  id: string,
  data: GiftCouponThemeUpdate,
  role: LowerRole,
): Promise<GiftCouponTheme> => {
  const res = await api_.patch(`/${role}/gift-coupon-theme/${id}`, data);
  return res.data;
};

// 삭제
export const deleteGiftCouponTheme = async (
  id: string,
  role: LowerRole,
): Promise<void> => {
  await api_.delete(`/${role}/gift-coupon-theme/${id}`);
};
